const doc = [({"da":({"js":({"admin":({"photo_products":({"table":({"unknown_resource_type":"Ukendt resourcetype: %{resource_type}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;